<template>
  <div class="btn-group consult-navigation">
    <button class="btn btn-default"
            v-on:click="isStepDisabled(previousStep.slug) ? '' : changeStep(previousStep.slug)"
            v-tooltip="stepDisabledText(previousStep.slug, previousStep)"
            :class="{ disabled: isStepDisabled(previousStep.slug) }">
      <span class="glyphicon glyphicon-chevron-left"></span>
      {{previousStep.title}}
    </button>

    <button class="btn btn-default" type="button">
      <VDropdown style="display: inline-block"
                 :offset="[0, 16]"
                 :placement="placement"
                 >

      <span>
        Step {{ currentStep }} of {{ totalSteps }}
        <span class="caret"></span>
      </span>

      <template #popper>
        <div class="btn-group-vertical" role="group" aria-label="...">
          <template v-for="(stepData, stepSlug) in consultSteps">
            <button :key="`step-${stepSlug}`"
                    v-close-popper
                    class="btn btn-default"
                    v-tooltip="stepDisabledText(stepSlug, stepData)"
                    :class="getStepClassess(stepSlug, stepData)"
                    @click="isStepDisabled(stepSlug) ? '' : changeStep(stepSlug)">
              {{stepData.title}}
            </button>
          </template>
        </div>
      </template>
      </VDropdown>
    </button>
    <button class="btn btn-default"
            v-on:click="isStepDisabled(nextStep.slug) ? '' : changeStep(nextStep.slug)"
            v-tooltip="stepDisabledText(nextStep.slug, nextStep)"
            :class="{ disabled: isStepDisabled(nextStep.slug) }">
      {{nextStep.title}}
      <span class="glyphicon glyphicon-chevron-right"></span>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ConsultNavigation',
  props: {
    placement: { default: 'bottom', type: String },
  },
  methods: {
    ...mapActions('currentConsult', [
      'setSection',
    ]),
    changeStep(stepSlug)
    {
      this.setSection(stepSlug)
      this.$emit('step-changed')
    },
    stepDisabledText(stepSlug, stepData)
    {
      if (stepSlug == '') { return null }

      if (this.isStepDisabled(stepSlug))
      {
        if (stepData.dependsOn.includes('__all__')) {
          return 'All required fields must be completed before a consult can be signed. Use the home button to save the consult and return to the home page.'
        } else {
          return `This step depends on: ${stepData.dependsOn.map(step => this.consultSteps[step].title).join(', ')}.`
        }
      }
      return null
    },
    hasRequiredFields(stepSlug)
    {
      if (this.isReadOnly) { return true }
      let stepData = this.consultSteps[stepSlug]
      return (stepData.requiredFields
        && stepData.requiredFields.length > 0
        && !stepData.complete)
    },
    isStepDisabled(stepSlug)
    {
      if (this.isReadOnly) {
        // all steps are enabled except for `previous` on first one and `next`
        // on last one
        return stepSlug == ''
      }
      if (stepSlug == '') { return true }
      let stepData = this.consultSteps[stepSlug]

      // No need to try to disable it, doesnt have any requirements
      if (!stepData.dependsOn) { return false }

      let requiredSteps = (stepData.dependsOn.includes('__all__'))
        ? Object.keys(this.consultSteps)
        : stepData.dependsOn

      return !requiredSteps.every(step => {
        return (this.hasRequiredFields(step))
          ? this.consultSteps[step].complete
          : true
      })
    },
    getStepClassess(stepSlug, stepData)
    {
      let classes = []
      if ((this.currentStep - 1) == Object.keys(this.consultSteps).indexOf(stepSlug)) { classes.push('active') }
      if (this.isReadOnly) { return classes }
      if (stepData.visited) { classes.push('visited') }
      if (this.hasRequiredFields(stepSlug)) { classes.push('hasRequiredFields') }
      if (this.isStepDisabled(stepSlug)) { classes.push('disabled') }
      return classes
    },
  },
  computed: {
    ...mapGetters('currentConsult', [
      'currentStep',
      'totalSteps',
      'consultSteps',
      'previousStep',
      'nextStep',
      'isReadOnly',
    ]),
  }
}
</script>
<style>

.visited {
  color: green !important
}

.hasRequiredFields {
  color: red !important;
}

.consult-navigation {
  margin: 1rem;
}
</style>
